import { useState } from 'react';
import { Pagination } from 'components/common/pagination';

export const usePagination = (totalRecords, numberPerPage, initialCurrentPage = 1) => {
  const [currentPage, setcurrentPage] = useState(initialCurrentPage);
  const [isPageChange, setIsPageChange] = useState(false);
  const setPage = page => {
    setcurrentPage(page);
    setIsPageChange(true);
  };
  return {
    currentPage,
    pageSize: numberPerPage,
    pageNumber: currentPage,
    isPageChange,
    paginationElement: currentPage && (
      <Pagination
        totalRecords={totalRecords}
        numberPerPage={numberPerPage}
        currentPage={currentPage}
        setCurrentPage={i => setPage(i)}
      />
    )
  };
};
